import { render } from "./set-company.vue?vue&type=template&id=371cdcae&scoped=true&ts=true&lang=pug"
import script from "./set-company.vue?vue&type=script&lang=ts"
export * from "./set-company.vue?vue&type=script&lang=ts"

import "./set-company.vue?vue&type=style&index=0&id=371cdcae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371cdcae"]])

export default __exports__